module.exports = __webpack_public_path__ + "img/soft-bg-4.cdacbc7a.png";